import { QueryClient, UseQueryOptions, useQuery } from "@tanstack/react-query";

import { TUserAuthData } from "@storage/session/types";
import { appTokenStorage, userAuthDataStorage } from "@storage/sessionStorage";

import { STALE_MINUTES_FIVE } from "@configs/constants";

export const createQueryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: STALE_MINUTES_FIVE,
			// refetchOnWindowFocus: false,
			retry: false,
		},

		mutations: {},
	},
});

export const useAuthQuery = <TQueryFnData = unknown, TError = unknown, TData = TQueryFnData>(
	options: UseQueryOptions<TQueryFnData, TError, TData>,
) => {
	const app_token = appTokenStorage.getItem();
	const userData = userAuthDataStorage.getItemAsJson<TUserAuthData>();

	return useQuery({
		...options,
		enabled: app_token !== null && userData !== null,
	});
};
